var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.948,
    height: 22.597,
    viewBox: "0 0 16.948 22.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-i-clpb{fill:#232323;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1715 -94)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1718.766 94)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-i-clpb",
    d: "M1727.945,97.766h-8.474A.471.471,0,0,1,1719,97.3v-.942A2.356,2.356,0,0,1,1721.354,94h4.708a2.356,2.356,0,0,1,2.354,2.354V97.3A.471.471,0,0,1,1727.945,97.766Zm-8-.942h7.532v-.471a1.414,1.414,0,0,0-1.412-1.412h-4.708a1.414,1.414,0,0,0-1.412,1.412Z",
    transform: "translate(-1719 -94)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1715 95.883)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-i-clpb",
    d: "M1731.477,116.714h-16.007a.471.471,0,0,1-.471-.471V96.471a.471.471,0,0,1,.471-.471h1.883a.471.471,0,0,1,0,.942h-1.413v18.831h15.065V96.942h-1.412a.471.471,0,0,1,0-.942h1.883a.471.471,0,0,1,.471.471v19.773A.471.471,0,0,1,1731.477,116.714Z",
    transform: "translate(-1715 -96)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1717.825 101.532)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.708)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-i-clpb",
    d: "M1729.12,102.942h-5.649a.471.471,0,0,1,0-.942h5.649a.471.471,0,0,1,0,.942Z",
    transform: "translate(-1723 -102)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a-i-clpb",
    d: "M1720.824,102.942h-2.354a.471.471,0,1,1,0-.942h2.354a.471.471,0,0,1,0,.942Z",
    transform: "translate(-1718 -102)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1717.825 104.985)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.708)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-i-clpb",
    d: "M1729.12,106.609h-5.649a.471.471,0,0,1,0-.942h5.649a.471.471,0,0,1,0,.942Z",
    transform: "translate(-1723 -105.667)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a-i-clpb",
    d: "M1720.824,106.609h-2.354a.471.471,0,1,1,0-.942h2.354a.471.471,0,0,1,0,.942Z",
    transform: "translate(-1718 -105.667)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1717.825 108.437)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.708)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-i-clpb",
    d: "M1729.12,110.275h-5.649a.471.471,0,0,1,0-.942h5.649a.471.471,0,0,1,0,.942Z",
    transform: "translate(-1723 -109.333)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a-i-clpb",
    d: "M1720.824,110.275h-2.354a.471.471,0,1,1,0-.942h2.354a.471.471,0,0,1,0,.942Z",
    transform: "translate(-1718 -109.333)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1717.825 111.889)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.708 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-i-clpb",
    d: "M1729.12,113.942h-5.649a.471.471,0,0,1,0-.942h5.649a.471.471,0,0,1,0,.942Z",
    transform: "translate(-1723 -113)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-i-clpb",
    d: "M1720.824,113.942h-2.354a.471.471,0,1,1,0-.942h2.354a.471.471,0,0,1,0,.942Z",
    transform: "translate(-1718 -113)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.ce1a59ac.svg";
export { ForwardRef as ReactComponent };